module.exports = __webpack_public_path__ + "static/media/Frame.604fed44.png";